import * as React from 'react';

import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { ShareTable } from '../../../shared';
import { Paper, Typography, LinearProgress } from '@material-ui/core';
import { QueryFilter, QUERY_FILTER_PUBLISHER } from 'src/component/shared';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedPublisherShare } from 'src/component/shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface IPublisherEconomicGroupShareProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherEconomicGroupShareState {
    customFilter: {
        isChart: boolean
    }
}

const dataFilled = (data: any) => {
    return data && data.publisherEconomicGroupShare && !!data.publisherEconomicGroupShare.length
}

const PUBLISHER_ECONOMIC_GROUP_SHARE = gql`
query publisherEconomicGroupShare($customFilter:  PublisherCustomFilter) {
    publisherEconomicGroupShare(publisherCustomFilter: $customFilter) {
        billing,
        name,
        value,
        volume
    }
}
`;

export class PublisherEconomicGroupShare extends React.Component<IPublisherEconomicGroupShareProps, IPublisherEconomicGroupShareState> {
    constructor(props: IPublisherEconomicGroupShareProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            }
        }
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
              "isChart": this.state.customFilter.isChart,
            }
        };

        return (
            <Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}>
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

                    let dataCache = GetCacheIfExists('publisher-data');
                    const hasNoFilterAppliedPublisher = HasNoFilterAppliedPublisherShare(clientC);

                    if( hasNoFilterAppliedPublisher && dataCache != null && dataCache.publisherEconomicGroupShare != null ) {
                        return this.dataToRend(dataCache, false);
                    } else {
                        return (
                            <Query query={PUBLISHER_ECONOMIC_GROUP_SHARE} variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, [])}>
                                {({ loading, error, data}) => {

                                    if ( hasNoFilterAppliedPublisher && data != null && data.publisherEconomicGroupShare != null ) {
                                        if(dataCache != null && dataCache !== undefined) {
                                            dataCache.publisherEconomicGroupShare = data.publisherEconomicGroupShare;
                                        } else {
                                            dataCache = data;
                                        }
                                        SetDataToSession('publisher-data', dataCache);
                                    }

                                    return this.dataToRend(data, loading);
                                }}
                            </Query>
                        );
                    }

                }}
            </Query>
        );



        
    }

    private dataToRend (data:any, loading:any) {
        return  (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="headline" className="panel-title" component="title">
                    Share por Grupo Econômico
                </Typography>
                {
                    loading ? <LinearProgress /> : (
                        dataFilled(data)
                        ?
                        (<ShareTable 
                            table_main={data.publisherEconomicGroupShare} 
                            table_01={data.publisherEconomicGroupShare} 
                            table_02={[]} 
                            title={"Share por Grupo Econômico"} 
                            showFirstTable={true}
                            showMax={5}
                         />)
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/economic-group-share/PublisherEconomicGroupShare.tsx